export const formatMoneyFromCents = value => {
  return (value / 100).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: '2',
    maximumFractionDigits: '2',
  });
};
